import { Init } from './init';

function App() {
  return <Init />;
}
export default App;
